import React, { useEffect } from "react";
import { Languages } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";
import { useLang } from "@/context/LanguageContext";

export default function Vetasphere() {
  const { t, isAr, toggle } = useLang();

  useEffect(() => {
    const dir = isAr ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", isAr ? "ar" : "en");
  }, [isAr]);

  return (
    <div className="min-h-screen flex flex-col" data-testid="vetasphere-page">
      <Seo
        title={{ en: "Vetasphere | Smart Account Vision", ar: "Vetasphere | سمارت أكاونت فيجن" }}
        description={{
          en: "Vetasphere — a page by Smart Account Vision.",
          ar: "Vetasphere — صفحة من سمارت أكاونت فيجن.",
        }}
      />
      <Header />
      <main className="flex-1 grid place-items-center bg-ivory px-6 py-24">
        <div className="text-center max-w-xl">
          <p className="text-sm font-semibold tracking-widest uppercase text-red-600" data-testid="vetasphere-kicker">
            Vetasphere
          </p>
          <h1 className="font-display text-4xl sm:text-5xl text-ink mt-4" data-testid="vetasphere-title">
            {t({ en: "Vetasphere", ar: "Vetasphere" })}
          </h1>
          <p className="mt-4 text-muted leading-relaxed" data-testid="vetasphere-subtitle">
            {t({
              en: "This page is coming soon.",
              ar: "هذه الصفحة قيد الإعداد.",
            })}
          </p>
          <button
            type="button"
            onClick={toggle}
            data-testid="vetasphere-lang-toggle"
            className="mt-8 inline-flex items-center gap-2 h-11 px-6 rounded-full border border-navy/20 text-navy font-semibold hover:bg-navy hover:text-white transition-colors"
          >
            <Languages className="h-4 w-4" />
            {t({ en: "عربي", ar: "English" })}
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
}
